import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import Glide from '@glidejs/glide';
import { Controls, Breakpoints, Autoplay } from '@glidejs/glide/dist/glide.modular.esm.js'
import { QuotationComponent } from "../../includes/quotation/quotation.component";
import { BannerSliderImage } from '../../models/banner-slider-image.model';
import { PageResizeService } from '../../services/page-resize.service';
import { debounceTime } from "rxjs/operators";
import { RouterLink } from '@angular/router';


@Component({
  selector: 'pc-banner-slider',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './banner-slider.component.html',
  styleUrl: './banner-slider.component.scss'
})
export class BannerSliderComponent implements OnInit, AfterViewInit {
  @Input() imageList: BannerSliderImage[] = [];
  activeImage: BannerSliderImage | null = null;

  glider: any;

  resizingPage = false;
  windowWidth: number = 0 || window.innerHeight;
  windowHeight: number = 0 || window.innerWidth;

  showProceedButton: boolean = false;

  constructor(
    private pageResizeService: PageResizeService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Initialize the slider
    this.glider = new Glide('.banner-glide', {
      type: 'carousel',
      perView: 1,
      gap: 0,
      focusAt: 'center',
      autoplay: 7500,
    }).mount({ Controls, Breakpoints, Autoplay });

     // Page Resize
    this.pageResizeService.windowSize$
    .pipe(
      debounceTime(100)
    )
    .subscribe((size) => {
      if (this.windowWidth !== size.width || this.windowHeight !== size.height) {
        this.isBannerGlideTall();
      }
      this.windowWidth = size.width;
      this.windowHeight = size.height;
      this.resizingPage = false;
    });
    
    this.pageResizeService.windowSize$.subscribe(() => {
      this.resizingPage = true;
    });
  }

  isBannerGlideTall() {
    const bannerGlide = document.querySelector('.banner-glide') as HTMLElement;
    
    if (bannerGlide) {
      const bannerHeight = bannerGlide.offsetHeight;
      const windowHeight = window.innerHeight;
      
      this.showProceedButton = bannerHeight >= windowHeight * 0.8;
    }
    // console.log('%cBanner is big: ' + (bannerHeight >= windowHeight * 0.8), 'color: #f793faff; font-weight: bold;');
    // return bannerHeight >= windowHeight * 0.8;
  }

  onBannerGlideEnter() {
    this.glider.pause();
  }
  onBannerGlideLeave() {
    this.glider.play();
  }

  scrollToExperience() {
    const el = document.getElementById('experience');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }

}

